// assets/custom-cart-line.js
function handleCartLineDelete() {
  const deleteButtons = document.querySelectorAll(".remove_cart_option");
  deleteButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const productId = this.getAttribute("data-product_id");
      const key = this.getAttribute("data-key");
      const variantId = this.getAttribute("data-variant_id");
      const quantity = this.getAttribute("data-quantity");
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          // Optionally, you can refresh the cart or update the UI here
          location.reload();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  handleCartLineDelete();
});

document.addEventListener("drawerOpen.CartDrawer", function () {
  setTimeout(() => {
    handleCartLineDelete();
  }, 1000);
});

document.addEventListener("cart:updated", function () {
  setTimeout(() => {
    handleCartLineDelete();
  }, 1000);
});
